import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const FARM_INFORMATION = {
  getAllDestinationsList: {
    success: "DESTINATIONS_GET_ALL_SUCCESS",
    error: "DESTINATIONS_GET_ALL_ERROR"
  }
};

export const getAllDestinationsList = (destinationType = "internal", harvestYear=harvestYearDetail().name) => {
  return (dispatch,getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
 let url = `/ntrac/destination/destinationType/${
  userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
  }/${harvestYear}?destinationType=internal`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = moment(item.updatedAt).format('ll');
        });
        dispatch({
          type: FARM_INFORMATION.getAllDestinationsList.success,
          data
        });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/farmInformation/action.js